import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ConsultantSelectedService {
  private craSelected: any;

  // Save the Consultant element
  setConsultantSelected(cra: any): void {
    this.craSelected = cra;
  }

  // Retrieve the Consultant element
  getConsultantSelected(): any {
    return this.craSelected;
  }

  hasConsultantSelected(): boolean {
    return !!this.craSelected;
  }
}
